import { F_CLOUD_TASK_TYPE } from '@/utils/const';
import request, { ResponseProps } from '@/utils/request';

import type { TaskState } from './useTaskList';

// export type TaskType = 0 | 1 | 2; // 0-父任务，1-子任务，2-批量任务

export enum TaskType {
  PARENT = 0,
  CHILD = 1,
  BATCH = 2,
}

export type QueryType = {
  cloudTaskType: F_CLOUD_TASK_TYPE;
  taskType: number;
};
export interface TaskListParams {
  queryTypes: QueryType[];
  pageNum: number;
  pageSize: number;
  includeStates?: TaskState[];
}

// Asset item in the response
export interface AssetItem {
  id: number;
  type: number; // 1-文件夹，2-图片，3-视频，4-字体,5-音频,6- 音色音频 ，7- zip 文件,8-文本
  title: string;
  desc: string;
  fileUrl: string;
  createTime: string;
  duration: number;
  cover: string;
  customType: string;
  businessId?: string;
  cloudTaskType: F_CLOUD_TASK_TYPE;
  extendInfo: {
    prompt?: string; // for VIDEO_GENERATE, IMAGE_GENERATE
    promptImage?: string; // for VIDEO_TRANSLATE
    originVideoUrl?: string;
    originCoverUrl?: string;
    noSubtitlesVideoUrl?: string;
    srtUrl?: string;
    originSrtUrl?: string;
    targetLanguage?: string;
    peopleVoiceUrl?: string;
    backgroundUrl?: string;
    voiceSrtUrl?: string;
    voiceJsonUrl?: string;
    taskExtraParam?: string; // JSON string of extra params
    subtitleProperties?: {
      fillColor: number[];
      isStroke: boolean;
      strokeColor: number[];
      strokeWidth: number;
      isBold: boolean;
      fontName: string;
      startPos: number;
      height: number;
      lineSpacing: number;
    };
    [key: string]: any;
  };
  [key: string]: any;
}

// Task item in the response
export interface TaskItem {
  id: number;
  taskId: string;
  businessId: string;
  taskType: number;
  type: number;
  state: number;
  processCost: number;
  createTime: number;
  videoPreviewUrl: string;
  videoTitle: string;
  videoUrl: string;
  engineCode: string;
  engineMessage: string;
  cloudTaskType: F_CLOUD_TASK_TYPE;
  fileUrl?: string;
  extendInfo?: {
    prompt?: string;
    promptImage?: string;
    taskExtraParam?: string; // JSON string of extra params
    [key: string]: any;
  };
  [key: string]: any;
}

// API response structure
export interface CreationDetail {
  taskId: number;
  title?: string;
  createTime?: number;
  cloudTaskType?: F_CLOUD_TASK_TYPE;
  assetList: AssetItem[];
  taskList: TaskItem[];
  batchTaskList: any[];
  extendJson?: string;
}

export interface CreationListResponse {
  creationDetailList: CreationDetail[];
}

export const fetchTaskList = async (
  data: TaskListParams,
): Promise<ResponseProps<CreationListResponse>> => {
  return await request('/api/rest/dlt/f/cloud/my/create', {
    method: 'POST',
    data,
  });
};

// Batch detail response (same structure as CreationDetail but for a single batch)
export interface BatchDetailResponse {
  assetList: AssetItem[];
  taskList: TaskItem[];
  batchTaskList: any[];
}

export const getBatchDetail = async (
  taskId: number,
): Promise<ResponseProps<BatchDetailResponse>> => {
  return await request('/api/rest/dlt/cloud/batch/detail', {
    method: 'POST',
    data: { parentId: taskId },
  });
};

// Parent task detail response (single task, not a batch)
export interface ParentTaskDetailResponse {
  id: number;
  businessId: string;
  type: number; // task type
  state: number; // 0-waiting, 1-processing, 2-completed, 3-failed
  taskType: number;
  createTime: number;
  modifyTime: number;
  videoTitle: string;
  videoUrl: string;
  videoPreviewUrl: string;
  processCost: number;
  dubbingModel: number;
  outputs: any[];
}

export const getParentDetail = async (
  taskId: number,
): Promise<ResponseProps<ParentTaskDetailResponse>> => {
  return await request('/api/rest/dlt/chat/task/detail', {
    method: 'POST',
    data: { taskId },
  });
};
